// extracted by mini-css-extract-plugin
module.exports = {"clickable":"Icon_clickable__3ZZLc"};